/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Revoked_DescInputs */



/**
* | output |
* | --- |
* | "Access to the {provider} integration was revoked from a member." |
*
* @param {Audit_Details_Integration_Revoked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_revoked_desc = /** @type {((inputs: Audit_Details_Integration_Revoked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Revoked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einem Mitglied wurde der Zugriff auf die Integration ${i?.provider} entzogen.`)
	return /** @type {LocalizedString} */ (`Access to the ${i?.provider} integration was revoked from a member.`)
});